import React from "react";
import styled from "styled-components";

import ImageQuestion from "@/components/ImageQuestion";
import { IThemeProps } from "@/styles/Theme";

export type QuizBodyProps = {
  questionImage?: string;
  children?: JSX.Element;
};

type SectionProps = IThemeProps<{}>;
const Section = styled.section<SectionProps>`
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 510px;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    max-width: 310px;
  }

  padding: ${(props: any) => props.theme.spacing.desktop.s500}px
    ${(props: any) => props.theme.spacing.desktop.s800}px;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    padding: ${(props: any) => props.theme.spacing.mobile.s500}px
      ${(props: any) => props.theme.spacing.mobile.s500}px;
  }
`;

type ChildrenProps = IThemeProps<{ noMarginTop: boolean }>;
const Children = styled.div<ChildrenProps>`
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  flex-flow: wrap;
  margin-top: ${(props: any) =>
    props.noMarginTop ? 0 : props.theme.spacing.desktop.s500}px;
  max-width: 384px;
`;

export class QuizBody extends React.Component<QuizBodyProps> {
  public render(): JSX.Element {
    const { questionImage } = this.props;
    return (
      <Section>
        {questionImage && <ImageQuestion imageUrl={questionImage} />}
        <Children noMarginTop={!questionImage}>{this.props.children}</Children>
      </Section>
    );
  }
}
